import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { CompetencySpiderChart } from '../../types/FeedbackMyOverview';

const getSpiderChartData = async (employeeId = null) => {
  try {
    const url = endpoints.competency.spiderChart;
    const queryParams = employeeId ? { emp_id: employeeId } : null;
    // @ts-expect-error API
    const res = await sendRequest({
      url,
      method: 'GET',
      credentials: 'include',
      queryParams,
    });
    return res?.entity;
  } catch (error) {
    console.error('Error fetching spider chart data : ', error);
    throw new Error(error);
  }
};

export const useGetSpiderChartQuery = (employeeId = null) =>
  useQuery<CompetencySpiderChart>({
    queryKey: [REACT_QUERY_KEYS.spiderChart, employeeId],
    queryFn: () => getSpiderChartData(employeeId),
  });
